export default {
	title: 'safety',
	components: [
		{ title: 'max_power_protection', component: 'max_power_protection_g2' },
		{ title: 'max_current_protection', component: 'max_current_protection_g2' },
		{
			title: 'voltage_protection',
			component: 'dimmer_voltage_protection',
		},
	],
};
